import { Stack } from 'expo-router';

export default function AuthLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="login" options={{ title: 'Per Diem · Sign In' }} />
      <Stack.Screen name="callback" options={{ title: 'Per Diem' }} />
    </Stack>
  );
}
